module.exports = __webpack_public_path__ + "img/制御工学1_9.28dfc543.png";